import { render, staticRenderFns } from "./ReportStatisticsItemCard.vue?vue&type=template&id=0721e9e6&scoped=true&"
import script from "./ReportStatisticsItemCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatisticsItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721e9e6",
  null
  
)

export default component.exports